import dayjs from 'dayjs';

// Shared by the Kubernetes vulnerabilities dashboard cards.

// Matches the pie cards' header so every card in the grid lines up.
export const CARD_TITLE_STYLE = {
  fontSize: '16px !important',
  borderTopLeftRadius: '8px',
  borderTopRightRadius: '8px',
  padding: '11.04px 15px',
  margin: '0px',
};

// Card body under the 40px ContentBox header.
export const CARD_BODY_HEIGHT = 'calc(100% - 40px)';

export const compactNumber = new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 });

// Bucket keys arrive already in the viewer's timezone (the request sends it), as `YYYY-MM-DD` for
// daily buckets and `YYYY-MM-DD HH:00:00` for hourly ones, so they are formatted, not converted.
// Medium, low and unknown fold into Other. `resources` (distinct affected resources) rides along for the
// cards that plot it.
export const toSeverityRows = (trend, isHourly = false) => {
  const today = dayjs();
  return (Array.isArray(trend) ? trend : []).map(item => {
    const date = dayjs(item.date);
    const isValid = date.isValid();
    let label = item.date ?? '';
    let fullDate = item.date ?? '';
    if (isValid && isHourly) {
      label = date.format('HH:mm');
      fullDate = date.format('ddd, MMM DD · HH:mm');
    } else if (isValid) {
      label = `${date.format('ddd')} | ${date.isSame(today, 'day') ? 'Today' : date.format('MMM DD')}`;
      fullDate = date.format('ddd, MMM DD YYYY');
    }

    return {
      label,
      fullDate,
      critical: item.critical ?? 0,
      high: item.high ?? 0,
      other: (item.medium ?? 0) + (item.low ?? 0) + (item.unknown ?? 0),
      resources: item.resources ?? 0,
    };
  });
};

export const hasSeverityValues = rows => rows.some(row => row.critical || row.high || row.other);

export const bucketTooltipLabel = (_, payload) => payload?.[0]?.payload?.fullDate ?? '';
